export default "__VITE_ASSET__d7e72efe__"